const verificarDisponibilidadeOnibus = async ({
  api,
  token,
  onibus_id,
  data_inicio,
  data_fim,
  ignorar_id = null
}) => {

  if (!onibus_id || !data_inicio || !data_fim) return { disponivel: true };

  const formatarData = (dataISO) => {
    if (!dataISO) return "";
    const data = new Date(dataISO);
    return data.toLocaleDateString("pt-BR");
  };

  try {

    const params = {
      onibus_id,
      data_inicio,
      data_fim,
    };

    if (ignorar_id) {
      params.ignorar_id = ignorar_id;
    }

    const res = await api.get(
      "/api/orcamentos/disponibilidade-onibus",
      {
        params,
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (!res.data.disponivel) {

      const conflitos = res.data.conflitos.map(c => ({
        mensagem: `Ônibus indisponível de ${formatarData(c.data_inicio)} até ${formatarData(c.data_fim)}, pois está alocado em uma viagem de ${c.cliente_nome}`,
        raw: c
      }));

      return {
        disponivel: false,
        conflitos
      };
    }

    return { disponivel: true };

  } catch (error) {
    console.error("Erro ao verificar disponibilidade:", error);

    return {
      disponivel: false,
      erro: true
    };
  }
};

export default verificarDisponibilidadeOnibus;